module.exports = __webpack_public_path__ + "static/media/imageIcon.26cb6239.svg";